import { cn } from '@/utils/styles';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@design-system/Carousel';
import EducationVideoCard from './EducationVideoCard';
import { useGetEducationSeriesVideoList } from '@/features/HomeViewModels/EducationVideoSeries.view.model';
import EducationVideoShimmer from './EducationVideoShimmer';

const EducationVideoCarousel = ({ screen }: { screen: string }) => {
  const { educarouselData, isEducarouselLoading, isEducarouselError } =
    useGetEducationSeriesVideoList({
      screen: screen,
    });
  const className = (screen === 'health' || screen === 'bio_age_detail') ? 'dark' : 'light';

  if (isEducarouselLoading) {
    return <EducationVideoShimmer />;
  }

  if (isEducarouselError || !educarouselData?.length) {
    return;
  }

  return educarouselData?.map((seriesData, index) => (
    <div key={index} className="mt-8 select-none">
      <p className={cn(`typography-h1 mb-4 text-primary ${className}`)}>
        {seriesData.playlist_title}
      </p>
      <Carousel
        className="relative"
        opts={{
          align: 'start',
          dragFree: true,
        }}
      >
        <CarouselContent className="ml-0 gap-3">
          {seriesData.video_list.map((playlistData, index) => (
            <CarouselItem key={`skeleton-${index}`} className="-pl-2 basis-80">
              <EducationVideoCard videoData={playlistData} screen={screen} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden" />
        <CarouselNext className="hidden" />
      </Carousel>
    </div>
  ));
};

export default EducationVideoCarousel;
